import React from 'react';

const OrderLoading = () => {
  return (
    <h2 className='font-bold text-center md:h-[200px] flex justify-center items-center mx-auto text-lg md:text-2xl'>
      Loading...
    </h2>
  );
};

export default OrderLoading;
